import { render } from "./SpaDaySpaGarden.vue?vue&type=template&id=23536136&scoped=true"
import script from "./SpaDaySpaGarden.vue?vue&type=script&lang=js"
export * from "./SpaDaySpaGarden.vue?vue&type=script&lang=js"

import "./SpaDaySpaGarden.vue?vue&type=style&index=0&id=23536136&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23536136"]])

export default __exports__